import { AccordionItem } from '@mm/components';
import { EnhancedPlan, PlanSubtypes } from '@mm/state/interfaces/subscription';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import React from 'react';
import styles from './BillingPlans.module.css';
import { ContactsManagementDescription } from './ContactsManagementDescription';
import { Plan } from './Plan';
import { PlanDescription } from './PlanDescription';
import { BillingPlanCardProps } from './use-billing-plans';

export const BillingPlansVerticalLayout = ({
  options,
  getOptionParams,
}: {
  options: BillingPlanCardProps[];
  getOptionParams: (option: BillingPlanCardProps) => {
    downgrade?: EnhancedPlan;
    currentTag?: boolean;
    buttonNameAdjusted?: string;
  };
}) => (
  <div
    className={classNames(
      styles.content,
      styles.contentWhite,
      styles.mobileContent,
    )}
  >
    {options.map(option => (
      <div
        className={classNames(styles.card, {
          [styles.customCard]: option.isCustom,
        })}
        key={uniqueId()}
      >
        <Plan
          option={option}
          getOptionParams={getOptionParams}
          className={styles.mainBlockVerticalLayout}
        />
        {(option.points || option.secondaryPoints) && (
          <PlanDescription
            option={option}
            className={classNames(styles.pointsVerticalLayout, {
              [styles.freeTrialPoints]: option.isFreeTrial,
            })}
          />
        )}
        {option.costs && (
          <div
            className={classNames(styles.costs, styles.costsVerticalLayout, {
              [styles.costsCustomPlan]: option.isCustom,
              [styles.freeTrialPoints]: option.isFreeTrial,
            })}
          >
            {Array.isArray(option.costs)
              ? option.costs?.map(cost => (
                  <div key={uniqueId()} className={styles.cost}>
                    {cost}
                  </div>
                ))
              : option.costs}
          </div>
        )}
        {(option.isCustom ||
          option.planSubtypes?.includes(PlanSubtypes.billing2023v2)) && (
          <AccordionItem
            closeOnOutsideClick={false}
            caretStyleIcon
            title="Monthly contact management fee"
          >
            <ContactsManagementDescription
              css={{
                container: styles.column,
                content: styles.fullWidth,
              }}
            />
          </AccordionItem>
        )}
      </div>
    ))}
  </div>
);
